import React from "react";
import { FaSpinner } from "react-icons/fa";
import ReactTooltip from "react-tooltip";
import momentTimezone from "moment-timezone";
import { Link } from "react-router-dom";
import ui_utils from "../../SimpleForm/UI/uiUtils";
import moment from "moment";

export const applicationTypeResolver = (selectedCase) => {
  if (!!selectedCase.formId) {
    switch (selectedCase.formId) {
      case "9089":
        return ui_utils.capitalizeAllFirstChars(
          selectedCase.occupationType.replace("None/", "")
        );

      default:
        return selectedCase.formId;
    }
  }
  return "--";
};

export const RenderDate = (
  value,
  index,
  machineName = "",
  tz = "America/New_York"
) => {
  const _date = formatDate(value, tz);
  return (
    <>
      <span data-tip data-for={`${machineName}_${index}`}>
        {_date || "--"}
      </span>
      <ReactTooltip type="dark" effect="solid" id={`${machineName}_${index}`}>
        <span>{_date || "--"}</span>
      </ReactTooltip>
    </>
  );
};
export const formatDate = (value, tz = "America/New_York") => {
  value = Number(value);
  const _date = value
    ? momentTimezone(value).tz(tz).format("MMMM D, YYYY")
    : null;
  return _date;
};

export const getCaseOwnerName = (props, caseOwnerID) => {
  if (
    props.user &&
    props.user.data &&
    props.user.data.Group &&
    props.user.data.Group.Members
  ) {
    const members = props.user.data.Group.Members;
    let caseOwner = members.filter((mem) => mem.subjectId === caseOwnerID);
    return caseOwner[0]
      ? `${caseOwner[0].first_name || ""} ${caseOwner[0].last_name || ""}`
      : `--`;
  } else {
    return `--`;
  }
};

export const LinkBack = ({ location }) => {
  return location?.state?.prevPageTitle && location.state.prevPageUrl ? (
    <Link to={`${location.state.prevPageUrl}`} className="link-back">
      Back to {location.state.prevPageTitle}
    </Link>
  ) : null;
};
export const isDataRenderable = (data) => {
  return data && typeof data !== "object";
};
export const isPropertyRenderable = (data) => {
  return !["__typename"].includes(data);
};
export const getExpirationDate = (form_id, caseDetails, records) => {
  const conditionsToIgnore = !(
    (
      caseDetails?.externalStatus === "RFI ISSUED" &&
      caseDetails?.isExtensionApproved === 1
    ) // approved
  );

  if (
    form_id === "9089" &&
    caseDetails?.isExtensionApproved === -1 &&
    conditionsToIgnore
  ) {
    const reqExtRecords = [...records]
      .sort((a, b) => moment(b.timestamp).unix() - moment(a.timestamp).unix())
      .filter((rec) => rec.action === "Request Extension");
    return reqExtRecords?.[0]?.timestamp ?? null;
  }

  return null;
};
